import React from 'react';

// eslint-disable-next-line max-len
const SEHO = '/themes/theme/seho/logo.png';
const SEHO_DARK_LOGO = '/themes/theme/seho/logo.png';

const SehoTheme = {
  headerLogo: {
    src: SEHO,
    alt: 'Seho Logo',
    size: 60,
  },
  darkLogo: {
    src: SEHO_DARK_LOGO,
    alt: 'Seho Logo',
    size: 60,
  },
  linkStyle: {
    color: '#2683EF',
    fontWeight: 800,
    fontSize: '120%',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '4px solid #2683EF',
    height: 100,
  },
  title: 'Seho',
  isLightOnDark: false,
  organisationId: '7a8786cb-31ef-4bdf-8318-eb6ee0e23d2b',
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="60"
        src={SEHO} alt="Seho Logo"
      />
      <br /><br />
    </div>
  ),
  shareSite: 'https://share.seho.app',
};

export default SehoTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/seho.js
 **/